import {StorableSummary} from 'constants/SampleConstants';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import NavStore from 'nav/NavStore';

/**
 * Invalidate registry folder on storable create. Call when a storable is created so that the collapsed or
 * expanded sidepanel listing should refresh. For example, `StorableActions.createContainers` calls it so
 * that the registry's 'Inventory' section, if open, refreshes to show the newly created containers.
 *
 * Assumes that the storable is listed in its registry's 'Inventory' section and that the registry is
 * bootstrapped as a source in `NavStore.sources`.
 *
 * This approach was chosen over calling `FinderActions.refreshResults(NavConstants.REGISTRIES_FINDER_ID)`
 * directly because for consistency with DAO/action functions for create files and bulk import from
 * spreadsheet, which also invalidate the containing folder.
 */
export default function invalidateRegistryFolderOnCreate(storable: StorableSummary): void {
  const registry = NavStore.getSource(storable.storableSchema.registryId);
  if (registry) {
    FolderDAOCache.invalidateFolderContents(registry.rootFolder.api_identifier);
  }
}
